import { cloneDeep } from 'lodash';
import React, { Fragment } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import NumberField from '../../../Base/NumberField';

const engineLocations = ['aft', 'mid', 'fore', ''];
const engineTypes = ['Main Engine', 'Aux Engine', 'Emergency', 'Gen', 'Power Packs', 'Boilers'];
const defaultEngine = {
    type: undefined,
    number: undefined,
    capacity: undefined,
    rpm: undefined,
    makeType: undefined,
};
const capacityUnits = {
    'Boilers': 'mt/hr',
    'Power Packs': 'm3/hr',
};

/** @param {object} props */
function OtherFields({
    getError, changeField, confirmed, engineLocation, windScale, modifiedFields,
    underStyle,engines,
}) {
    if (!engines || !engines.length) {
        engines = [{ ...defaultEngine }];
    }
    const addRow = () => {
        changeField({
            field: 'engines',
            value: [...cloneDeep(engines), { ...defaultEngine }]
        });
    };
    const removeRow = (index) => {
        const list = cloneDeep(engines);
        list.splice(index, 1);
        changeField({ field: 'engines', value: list });
    };
    return (
        <Fragment>
            <div className='row'>
                <div className='col-xs-6'>
                    <SelectField
                        value={engineLocation}
                        disabled={confirmed}
                        onChange={(e, i, value) => {
                            changeField({
                                field: 'engineLocation',
                                value
                            });
                        }}
                        errorText={getError('engineLocation')}
                        maxHeight={200}
                        name={`engineLocation`}
                        floatingLabelText='Engine location'
                        fullWidth

                        underlineStyle={modifiedFields && modifiedFields.includes('engineLocation') ? underStyle : null}
                    >
                        {
                            engineLocations.map((engineLocation, index) => {
                                return <MenuItem
                                    key={`${engineLocation}_${index}`}
                                    value={engineLocation}
                                    primaryText={engineLocation}
                                />
                            })
                        }
                    </SelectField>
                </div>
                <div className='col-xs-6'>
                    <SelectField
                        value={windScale}
                        disabled={confirmed}
                        onChange={(e, i, value) => {
                            changeField({
                                field: 'windScale',
                                value
                            });
                        }}
                        errorText={getError('windScale')}
                        maxHeight={200}
                        name={`windScale`}
                        floatingLabelText='WindScale'
                        fullWidth

                        underlineStyle={modifiedFields && modifiedFields.includes('windScale') ? underStyle : null}
                    >
                        <MenuItem value={0} primaryText={'0 (0—0,2 m/s)'} />
                        <MenuItem value={1} primaryText={'1 (0,3—1,5 m/s)'} />
                        <MenuItem value={2} primaryText={'2 (1,6—3,3 m/s)'} />
                        <MenuItem value={3} primaryText={'3 (3,4—5,4 m/s)'} />
                        <MenuItem value={4} primaryText={'4 (5,5—7,9 m/s)'} />
                        <MenuItem value={5} primaryText={'5 (8,0—10,7 m/s)'} />
                        <MenuItem value={6} primaryText={'6 (10,8—13,8 m/s)'} />
                        <MenuItem value={7} primaryText={'7 (13,9—17,1 m/s)'} />
                        <MenuItem value={8} primaryText={'8 (17,2—20,7 m/s)'} />
                        <MenuItem value={9} primaryText={'9 (20,8—24,4 m/s)'} />
                        <MenuItem value={10} primaryText={'10 (24,5—28,4 m/s)'} />
                        <MenuItem value={11} primaryText={'11 (28,5—32,6 m/s)'} />
                        <MenuItem value={12} primaryText={'12 (33 and more m/s)'} />
                    </SelectField>
                </div>
            </div>
            {engines.map((engine, index) => (
                <div className='row' key={`${engine.type}_${index}`}>
                    <div className='col-xs-3'>
                        <SelectField
                            value={engine.type}
                            onChange={(e, i, value) => {
                                changeField({
                                    field: `engines[${index}].type`,
                                    value,
                                });
                            }}
                            disabled={confirmed}
                            errorText={getError(`engines[${index}].type`)}
                            maxHeight={200}
                            name={`engines[${index}].type`}
                            floatingLabelText='Engine'
                            fullWidth
                            autoWidth
                            underlineStyle={modifiedFields && modifiedFields.includes(`engines[${index}].type`) ? underStyle : null}
                        >
                            {['', ...engineTypes].map(type => (
                                <MenuItem
                                    key={type}
                                    value={type}
                                    primaryText={type}
                                />
                            ))}
                        </SelectField>
                    </div>
                    <div className='col-xs-2'>
                        <NumberField
                            name={`engines[${index}].number`}
                            floatingLabelText='Number, pc'
                            value={engine.number || ''}
                            disabled={confirmed}
                            errorText={getError(`engines[${index}].number`)}
                            fullWidth
                            onChange={(e, value) => {
                                changeField({
                                    field: `engines[${index}].number`,
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes(`engines[${index}].number`) ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-2'>
                        <NumberField
                            name={`engines[${index}].capacity`}
                            floatingLabelText={`Capacity, ${capacityUnits[engine.type] || 'kw'}`}
                            value={engine.capacity || ''}
                            disabled={confirmed}
                            errorText={getError(`engines[${index}].capacity`)}
                            fullWidth
                            floatNumber
                            onChange={(e, value) => {
                                changeField({
                                    field: `engines[${index}].capacity`,
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes(`engines[${index}].capacity`) ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-2'>
                        <NumberField
                            name={`engines[${index}].rpm`}
                            floatingLabelText='RPM'
                            value={engine.rpm || ''}
                            disabled={confirmed}
                            errorText={getError(`engines[${index}].rpm`)}
                            fullWidth
                            floatNumber
                            onChange={(e, value) => {
                                changeField({
                                    field: `engines[${index}].rpm`,
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes(`engines[${index}].rpm`) ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-2'>
                        <TextField
                            name={`engines[${index}].makeType`}
                            floatingLabelText='Make/Type'
                            value={engine.makeType || ''}
                            disabled={confirmed}
                            errorText={getError(`engines[${index}].makeType`)}
                            fullWidth
                            onChange={(e, value) => {
                                changeField({
                                    field: `engines[${index}].makeType`,
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes(`engines[${index}].makeType`) ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-1'>
                        <div style={{ margin: '25px 0 0 0' }}>
                            {index === 0 && (
                                <IconButton
                                    disabled={confirmed}
                                    onClick={addRow}
                                >
                                    <ContentAddIcon color='green' />
                                </IconButton>
                            )}
                            {index !== 0 && (
                                <IconButton
                                    disabled={confirmed}
                                    onClick={() => {
                                        removeRow(index);
                                    }}
                                >
                                    <ContentRemoveIcon color='red' />
                                </IconButton>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </Fragment>
    );
}

export default OtherFields;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/OtherFields.jsx